// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"ReviewerPage_pageContainer__2xtlR","columns":"ReviewerPage_columns__1eEKd","content":"ReviewerPage_content__317El"};